module.exports = __webpack_public_path__ + "img/bgr-confetti-2.40516253.svg";